import { $qs, $qsa } from '../../utils/QuerySelector';
import { media } from '../../utils/MediaQueries';
import gsap from 'gsap';
import ScrollTrigger from 'gsap/ScrollTrigger';
import { fadeIn, fadeInUp, imageReveal, textFadeReveal } from '../../utils/OnScrollAnimations';

gsap.registerPlugin(ScrollTrigger);



function fullWidthImageBanner() {
    const banner = $qs('[data-target="full-width-image-banner"]');

    if (!banner) return;

    const image = $qs('[data-aos-target="image"]', banner);
    const overlays = $qsa('[data-aos-target="overlay"]', banner);
    const menu = $qs('[data-target="header-menu-nav"]');
    const breadcrumbs = $qs('[data-aos-target="breadcrumbs"]', banner);
    const title = $qs('[data-aos-target="title"]', banner);
    const parentTitle = $qs('[data-aos-target="parent-title"]', banner);
    const relatedPagesMenu = $qs('[data-aos-target="related-pages-menu"]', banner);

    // const { textRevealFrom, splitText } = textFadeReveal({element: title});

    const timeline = gsap.timeline({
        scrollTrigger: {
            trigger: banner,
            scrub: false,
            pin: false,
            start: 'top+=25% bottom'
        },
        onComplete: () => {
            // titleRevealChildSplit.revert();
            // titleRevealSplit.revert();
        }
    });

    timeline.addLabel('start');
    image && timeline.add(imageReveal({element: image}), 'start');
    overlays && timeline.add(fadeIn({element: overlays, opacity: 0.75}), '-=0.3');
    // menu && timeline.add(fadeIn(menu), '-=0.5');
    parentTitle && timeline.add(fadeInUp({element: parentTitle}), '-=0.3');
    timeline.addLabel('titleReveal', '-=1');
    // title && timeline.add(textRevealFrom, 'titleReveal');
    title && timeline.add(fadeInUp({element: title}), 'titleReveal');
    timeline.add(fadeInUp({element: relatedPagesMenu}), '-=1');
}

function mobileRelatedPagesMenu() {
    if (media.xl) return;

    const relatedPagesMenu = $qs('[data-target="related-pages-menu"]');

    if (!relatedPagesMenu) return;

    const relatedPagesMenuTrigger = $qs('[data-target="related-pages-menu-trigger"]');
    const relatedPagesMenuInner = $qs('[data-target="related-pages-menu-inner"]', relatedPagesMenu);

    relatedPagesMenuTrigger.addEventListener('click', () => {
        relatedPagesMenuTrigger.dataset.state = relatedPagesMenuTrigger.dataset.state === 'closed' ? 'open' : 'closed';
        $(relatedPagesMenuInner).slideToggle();
    });
}

function banners() {
    const banner = $qs('[data-name="banner"]');

    if (!banner) return;

    fullWidthImageBanner();
    mobileRelatedPagesMenu();
}

export default banners;